import { render, staticRenderFns } from "./statusApprovedDetails.vue?vue&type=template&id=0ee08663&scoped=true&"
import script from "./statusApprovedDetails.vue?vue&type=script&lang=js&"
export * from "./statusApprovedDetails.vue?vue&type=script&lang=js&"
import style0 from "./statusApprovedDetails.vue?vue&type=style&index=0&id=0ee08663&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee08663",
  null
  
)

export default component.exports